import React from 'react';
import Loading from '|/components/base/loading';
import { useIsInBucket } from '|/helpers/experiment';
import type { CompletePurchaseStepProps } from './complete-purchase.types';
import CompletePurchaseControl from './control';
import CompletePurchaseTreatment from './treatment';

const CompletePurchase: React.FC<CompletePurchaseStepProps> = props => {
  const isInPriceIsRightTreatment = useIsInBucket('pp-the-price-is-right', 'treatment', [
    'control'
  ]);

  if (isInPriceIsRightTreatment === null) return <Loading />;

  return isInPriceIsRightTreatment ? (
    <CompletePurchaseTreatment {...props} />
  ) : (
    <CompletePurchaseControl {...props} />
  );
};

export default CompletePurchase;
